/**
 * This component provides a functionality to user to update phone number into My Account
 */
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Pipe } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { IBreadcrumb } from '../../../core/breadcrumb/breadcrumbs.model';
import { BreadcrumbsService } from '../../../core/breadcrumb/breadcrumbs.service';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { EmailTextPromoService } from '../../../email-text-promo/email-text-promo.service';
import { MaskedPhoneNumberValidator } from '../validators/masked-phone-number-validator';
import { UpdateProfileService } from '../update-profile.service';
import { UpdateCriteriaObject, UpdateElectronicCommunicationInfo, EmailCommunicationInfo, PhoneCommunicationInfo } from '../models/update-profile-model';
import { GoogleAnalyticsService } from '../../../core/google-analytics/google-analytics.service';
import { UserSession } from '@mem-shared/user-session';


@Component({
  selector: 'mem-update-phone-number',
  templateUrl: './update-phone-number.component.html',
  styleUrls: ['./update-phone-number.component.scss']
})

/**
 *  Update Phone Number from My Profile and Email Text Promo
 */
export class UpdatePhoneNumberComponent implements OnInit {
  @ViewChild('phoneSuccessModal') phoneSuccessModel: ModalDirective;
  @ViewChild('termsConditions') termsConditions: ModalDirective;
  // Used for masking telephone number
  mask = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  // used to display headings on HTML page
  fromAddMobilePhoneNumber: Boolean;
  fromEditMobilePhoneNumber: Boolean;

  // used for modal pop-up
  modalRef: BsModalRef;
  showMultiFactor: Boolean;
  // this checks that form is submitted or not
  submitted: boolean;
  // error handling for duplicate phone number
  dulpicatePhone: Boolean = false;
  // form for update phone
  updatePhoneForm: FormGroup;
  // These variables are used as parameters for making service call
  responseRecordType: string[];
  // these variable are used to update phone details
  updateCriteriaObject: UpdateCriteriaObject;
  updateElectronicCommunicationInfoo: UpdateElectronicCommunicationInfo = Object();
  activePhoneNumber: number;
  mostRecentPhoneNumber: number;
  // used for error handeling
  serviceError: boolean;
 // Variable to show error message
 loading: boolean;
  /**
   * Getter for form field newPhone
   */
  get newPhone() {
    return this.updatePhoneForm.get('newPhone');
  }

  constructor(private fb: FormBuilder,
    private router: Router,
    private ga: GoogleAnalyticsService,
    private uploadProfileService: UpdateProfileService,
    private emailTextPromoService: EmailTextPromoService,
    public userSession: UserSession, private modalService: BsModalService, public breadcrumbsService: BreadcrumbsService) {

  }

  /**
   * This function is called on click of View General T&C link
   */
  viewGeneralTnC() {
    // this.modalRef = this.modalService.show(template);
    this.termsConditions.show();
  }

  /**
   * This function is called for navigating to page content
   */
  goToPageContent(urlReceived: String) {
    this.router.navigate(['pageindex/' + urlReceived]);
  }

  CaptureUpdatePhoneNumGA() {
    if (typeof this.ga.submitEventToGA === "function") {
      this.ga.submitEventToGA('Click : Change Phone Number', 'Change Phone Number');
    }
  }
  goToPageContentPolicy(urlReceived: String) {
    this.router.navigate(['pageindex/' + urlReceived]);
  }

  ngOnInit() {
    // checks if the component is called from add phone number link
    if (this.router.url.endsWith('addMobilePhoneNumber')) {
      this.fromAddMobilePhoneNumber = true;
      this.fromEditMobilePhoneNumber = false;
    }
    // checks if the component is called from edit phone number link
    if (this.router.url.endsWith('editMobilePhoneNumber')) {
      this.fromAddMobilePhoneNumber = false;
      this.fromEditMobilePhoneNumber = true;
    }
        
    this.showMultiFactor = (this.userSession.getMemberFeatureFlags().showMultiFactorAuthConsent == true) && (this.userSession.getMemberFeatureFlags().contactEmailConfirmed || this.userSession.getMemberFeatureFlags().contactPhoneConfirmed);
    this.submitted = false;
    this.updatePhoneNumberForm();
    this.fetchExistingPhoneNumber();
    //Capture change phone number event in GA
    this.CaptureUpdatePhoneNumGA();
    this.setBreadcrumbs();
  }

  /**
   * This function is called when save button is clicked
   */
  updatePhone() {
    this.submitted = true;
    this.loading = true;
    //  this.callEmailTextPromoService();
    if (this.updatePhoneForm.valid && !this.dulpicatePhone) {
      this.responseRecordType = ['text'];
      this.updateElectronicCommunicationInfoo.phoneCommunicationInfo = Object();
      this.updateElectronicCommunicationInfoo.phoneCommunicationInfo.newPhoneNumber = this.trimPhoneNumber(this.newPhone.value).toString();
      // this calls updateMemberCommunicationInfo to save current phone number
      this.uploadProfileService.updateMemberCommunicationInfo(this.updateElectronicCommunicationInfoo, this.responseRecordType).subscribe(
        data => {
          //showing popup model after success result getting
          this.phoneSuccessModel.show();
          this.loading = false;
        },
        error => {
          this.serviceError = true;
          this.loading = false;
        }
      );
    }else{
      this.loading = false;
    }
  }

  /* Creating form using form builder */
  private updatePhoneNumberForm() {
    this.updatePhoneForm = this.fb.group(
      {
        newPhone: ['', [Validators.required, MaskedPhoneNumberValidator]],
      },
      { updateOn: 'submit' }
    );
  }

  /**
  * Call the email Text promo service to store the values of Existing Phone Number
  */
  fetchExistingPhoneNumber() {
    this.emailTextPromoService.getMemberCommunicationInfo().subscribe(
      data => {
        this.activePhoneNumber = +data.communicationAndConsentDetails.phoneCommunicationInfo.activePhoneInfo.phoneNo;
        this.mostRecentPhoneNumber = +data.communicationAndConsentDetails.phoneCommunicationInfo.mostRecentPhoneInfo.phoneNo;
      }
    );
  }

  /**
   * This function will Happen on change In INput field of New Phone Number to check duplicate phone number
   */
  checkPhoneDuplicate(phoneNumber: string) {
    const newPhoneNumber = this.trimPhoneNumber(phoneNumber);
    if ((this.activePhoneNumber === newPhoneNumber) || (this.mostRecentPhoneNumber === newPhoneNumber)) {
      this.dulpicatePhone = true;
      return true;
    } else {
      this.dulpicatePhone = false;
      return false;
    }
  }

  /**
   * Remove the text mask from the phone number for posting to backend and validation.
   * Essentially just removes dashes and underscores.
   */
  private trimPhoneNumber(number): number {
    number = number.replace(/\-/g, '');
    number = number.replace(/\_/g, '');
    return +number;
  }

  /**
 * This function is used to navigate to the previous page from where it is being called
 */
  goToPreviousPage() {       
    if(this.router.url.indexOf('communicationpreference') === -1){
      this.router.navigate(["/emailTextPromo/home"]);
    }else{
      this.router.navigate(["/profile/communicationpreference"]);      
    }
  }

  /**
   * This function is used to load breadcrumbs for account recovery page based on conditions
   */
  setBreadcrumbs() {
    if (this.showMultiFactor && (this.userSession.getSession('previousUrl') === '/emailTextPromo/home' || this.userSession.getSession('previousUrl') === '/emailTextPromo')) {
      let breadcrumb: IBreadcrumb[] = [{
        label: 'Two step Verification',
        params: {},
        url: '/emailTextPromo/home'
      },
      {
        label: 'Edit Mobile Phone Number',
        params: {},
        url: ''
      }];
      this.breadcrumbsService.store(breadcrumb);
    }
    if (!this.showMultiFactor && (this.userSession.getSession('previousUrl') === '/emailTextPromo/home' || this.userSession.getSession('previousUrl') === '/emailTextPromo')) {
      let breadcrumb: IBreadcrumb[] = [
        {
          label: 'Account Recovery',
          params: {},
          url: '/emailTextPromo/home'
        },
        {
          label: 'Edit Mobile Phone Number',
          params: {},
          url: ''
        }];
      this.breadcrumbsService.store(breadcrumb);
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/update-profile/update-phone-number/update-phone-number.component.ts